import { GET_BIKE_MODELS_REQUEST, GET_BIKE_MODELS_REQUEST_SUCCESS, GET_BIKE_MODELS_REQUEST_FAILURE } from '../constants/bike_model.constants';

export const getBikeModelsRequest = (where, pagination) => ({
    type: GET_BIKE_MODELS_REQUEST, where, pagination,
});

export const getBikeModelsRequestSuccess = payload => ({ type: GET_BIKE_MODELS_REQUEST_SUCCESS, payload });
export const getBikeModelsRequestFailure = error => ({ type: GET_BIKE_MODELS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/get_bike_models.actions.js